<template>
    <div class="container">
        <div class="box">
            <h3 class="title reveal-bottom">{{ $t("cxc.t1") }}</h3>
            <div class="text reveal-bottom">
                <p>{{ $t("cxc.c1") }}</p>
                <p>{{ $t("cxc.c2") }}</p>
                <p>{{ $t("cxc.c3") }}</p>
            </div>
            <div class="box-wrap">
                <div class="item ">
                    <p class="reveal-bottom">{{ $t("cxc.c") }}</p>
                </div>
                <div class="item">
                    <img class="item-img" :src="img" alt="col" />
                </div>
                <div class="item">
                    <img class="item-img" :src="img1" alt="col" />
                </div>
                <div class="item reveal-bottom">
                    {{ $t("cxc.c1") }}<br />
                    {{ $t("cxc.c2") }}<br />
                    {{ $t("cxc.c3") }}<br />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "content2",
    data() {
        return {
            img: require("@/assets/images/cloud_xpress_connect_img_2.jpg"),
            img1: require("@/assets/images/cloud_xpress_connect_img_3.jpg"),
        };
    },
};
</script>
<style scoped>
.container {
    overflow: hidden;
    background-color: #fff;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #000000;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 183px;
}
.text {
    margin-top: 43px;
    margin-bottom: 194px;
}
.text > p {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 40px;
}
.box-wrap {
    display: flex;
    flex-wrap: wrap;
}
.item {
    width: 590px;
    height: 456px;
    box-sizing: border-box;
}
.item:nth-child(1) {
    background: #00a3d1;
}
.item-img {
    width: 100%;
    height: 100%;
}
.item:nth-child(1) > p {
    width: 450px;
    height: 100%;
    float: right;
    padding-right: 40px;
    box-sizing: border-box;
    font-size: 24px;
    color: #ffffff;
    line-height: 44px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.item:nth-child(4) {
    padding: 40px;
    box-sizing: border-box;
    font-size: 24px;
    color: #000;
    line-height: 45px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/Pages/CloudXpressConnect/Content1.vue